import { ServiceFetch } from '../service-fetch'

export default class OverTimeWorkListModel extends ServiceFetch {
    getOverTimeWorkListBy = (data) => this.authFetch({
        url: 'over-time-work-list/getOverTimeWorkListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}